import React from "react";
import { VaultFeedTitle } from "@/components/00-page-display/VaultFeedTitle";
import { VaultFeed } from "@/components/vault/feed/VaultFeed";

export const Display = () => {
  return (
    <>
      <VaultFeedTitle />
      <VaultFeed />
    </>
  );
};
